document.addEventListener("DOMContentLoaded", function () {
    const popup = document.querySelector("[data-login_popup]");
    
    if (!popup) return;

    const observer = new MutationObserver(() => {
        if (popup.classList.contains("active")) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }
    });

    observer.observe(popup, { attributes: true, attributeFilter: ["class"] });
});

